import React from 'react';
import { Image, View, Text, StyleSheet } from '@react-pdf/renderer';

function PdfIconStrip({ iconDetails, loadedImages, textStyle }) {
  // Calculate width based on icon count
  const iconCount = iconDetails.length;
  const iconWidth = `${100 / iconCount}%`;

  return (
    <View style={styles.iconStripContainer}>
      {iconDetails.map((icon, index) => {
        console.warn(`[Icon ${index}] Looking for:`, icon.img);
        console.warn(`[Icon ${index}] Caption:`, icon.caption);
        const base64Image = loadedImages.find(img => img.url.includes(icon.img));
        console.warn(`[Icon ${index}] Found:`, !!base64Image);
        if (!base64Image) {
          console.error(`[Icon ${index}] NOT FOUND! Available images:`, loadedImages.map(img => img.url));
        }

        return (
          <View style={[styles.iconItem, { width: iconWidth }]} key={icon.img}>
            {base64Image
              ? <Image src={base64Image.data.data} style={styles.iconImage} />
              : <Text style={textStyle}>Image not found</Text>
            }
            <Text wrap={false} style={[styles.iconCaption, textStyle]}>{icon.caption}</Text>
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  iconStripContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 15,
    marginBottom: 15,
  },
  iconItem: {
    alignItems: 'center',
    paddingHorizontal: 2,
  },
  iconImage: {
    width: '100%',
    height: 'auto',
    minHeight: 60,
  },
  iconCaption: {
    textAlign: 'center',
    marginTop: 8,
    fontSize: 10,
  },
});

export default PdfIconStrip;
